import React from 'react';
import moment from 'moment';
import { Col, Container, Card, CardImg, CardBody, CardTitle, CardText, Row, Button, CardFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignalStream } from '@fortawesome/pro-solid-svg-icons/faSignalStream';
import Video from 'routes/Products/components/Video';
import CarouselV3 from 'routes/Products/components/CarouselV3';
import { useWLC } from '../../../../products/WLC/contexts/WLCContext';

const GettingStartedTutorialSection = ({ cards = [], isMobile = false, tutorialVideoUrl = '' }) => {
  const { handleNav } = useWLC();

  return isMobile ? (
    <div className="pb-5 background-light-gray" id="wlc-week-resources">
      <CarouselV3
        cards={cards}
        noDescription={false}
        title="Knowing Your Way Around"
        darkText
        fullWidth
        className="carousel-full-description"
        handleNav={handleNav}
        titleTag="h4"
      />
      <Container>
        <Row>
          <Col>
            <h4 className="mt-0">Video Tutorial</h4>
            <Video videoDirectUrl={tutorialVideoUrl} />
          </Col>
        </Row>
      </Container>
    </div>
  ) : (
    <div className="pb-5 background-light-gray" id="wlc-week-resources">
      <Container>
        <Row>
          <Col lg="7">
            <Container fluid>
              <Row>
                <Col xs="12">
                  <h4>Knowing Your Way Around</h4>
                </Col>
                {cards && cards.length
                  ? cards.map((card, i) => {
                      const { title = null, description = null, icon } = card.displayProps || {};

                      const { id, slug, type, data } = card;

                      return (
                        <Col lg="4" key={id} className="mb-4">
                          <Card
                            onClick={
                              slug
                                ? () =>
                                    handleNav(
                                      null,
                                      type,
                                      type === 'link'
                                        ? (data?.url ?? slug)
                                        : type === 'zoomMeeting'
                                          ? (data?.recordingUrl ?? slug)
                                          : slug,
                                      null
                                    )
                                : null
                            }
                            style={{ cursor: slug ? 'pointer' : 'default', height: '100%' }}
                          >
                            {icon && (
                              <CardImg alt="" top tag={FontAwesomeIcon} icon={icon} size="4x" className="mt-3" />
                            )}
                            <CardBody>
                              <CardTitle tag="h6">{title}</CardTitle>
                              <CardText className="description">{description}</CardText>
                            </CardBody>
                          </Card>
                        </Col>
                      );
                    })
                  : null}
              </Row>
            </Container>
          </Col>
          <Col lg="5">
            <h4>Video Tutorial</h4>
            <Card>
              <CardBody>
                <Video videoDirectUrl={tutorialVideoUrl} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GettingStartedTutorialSection;
